/**
 * Shared z-index scale — mirrors `--fw-z-*` tokens in fever-component
 * (`fever-component/src/index.css`).
 *
 * Keep these values in sync with the fever/ui tokens so MUI-rooted overlays
 * (Dialog, Popover, Snackbar, Tooltip) and fever/ui overlays never collide.
 *
 * `modalNested` is the canonical answer to "fever/ui Dialog is underneath
 * MUI Dialog": pass `zIndex="nested"` to the fever/ui Dialog, or this value
 * to any other overlay that must sit above a base modal.
 */
export const zIndex = {
    drawer: 1200,
    modal: 1300,
    modalNested: 1400,
    popover: 1500,
    tooltip: 1600,
    toast: 1700
};

export default zIndex;
